module.exports = __webpack_public_path__ + "static/media/454A9170.26debd9e.jpg";